export const INTEROP_CHANGE_EVENT = 'INTEROP_CHANGE_EVENT';
export const ROUTE_CHANGE_EVENT = 'ROUTE_CHANGE_EVENT';
